
import React, { useState, useEffect } from 'react';
import {
    TextField, Button, InputLabel, MenuItem, FormControl, Select, Box, FormHelperText, Autocomplete, InputAdornment, IconButton
} from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import LinkedOrdersModal from './Modals/LinkedOrderModal'
import linkIcon from '../../../assets/images/link.svg'
import { Formik } from 'formik';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts } from '../../../redux/productSlice';
import { fetchUOMDetails } from '../../../redux/orderSlice';
import { useTranslation } from 'react-i18next';
const productSchema = yup.object({
    productName: yup.string().required('Product is required'),
    productQty: yup.number().required('Quantity is required').positive().integer(),
    productUom: yup.string().required('Unit is required'),
    productDescription: yup.string().max(300, 'Product description must be at most 300 characters'),
    blendPercentage: yup.number().required('Blend percentage is required').positive().max(100),
    glm: yup.number().required('Grams/Linear Meter is required').positive(),
    // gpg: yup.number().required('Linear Meter is required').positive(),
    mpg: yup.number().required('Meters/Garments is required').positive(),
});

const AddProductForm = ({ onSubmit, initialValues, actionType, currentStep, handleStepChange, handleNextStep, productId, productCount  // pass the productId here
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation()
    const defaultValues = {
        productId: '',
        // companykeyId: 224,
        productName: '',
        productDescription: '',
        productQty: '',
        productUom: '',
        blendPercentage: 100,
        gpg: '',
        glm: '',
        mpg: '',
        // userId: 10 // It should be dynamic
    };

    const findbyProductInitialize = initialValues.find(product => product.productId === productId)
    const companyRole = useSelector((state) => state.auth.userDetails?.company?.companyRoles || []);

    const editProductValue = actionType === 'edit' ? {
        productId: findbyProductInitialize?.productId || '',
        productName: findbyProductInitialize?.productName || '',
        productUom: findbyProductInitialize?.productUom || '',
        productQty: findbyProductInitialize?.productQty || '',
        productDescription: findbyProductInitialize?.productDescription || '',
        blendPercentage: findbyProductInitialize?.blendPercentage || 100,
        gpg: findbyProductInitialize?.gpg || '',
        glm: findbyProductInitialize?.glm || '',
        mpg: findbyProductInitialize?.mpg || '',
        // userId:1
    } : defaultValues;
    const productList = useSelector((state) => state.products.productList || []);
    const unitOptions = useSelector((state) => state.order.uomDetails?.data || []);


    // Map the data to the format required by the autocomplete component
    const productsOptions = productList.map(product => ({
        label: product.productName,
        value: product.productId
    }));
    useEffect(() => {
        const queryParams = {
            // companyId: '224'
            type: 'ORP'

        };
        // const companyKeyId = '224';
        dispatch(fetchUOMDetails(queryParams));
    }, [dispatch])
    useEffect(() => {
        // Assuming '224' is the company ID to fetch the suppliers
        const queryParams = {
            type: 'company'

        };
        // const companyKeyId = '224';
        dispatch(fetchProducts(queryParams));
    }, [dispatch]);
    // const handleSubmit = (event) => {
    // console.log("###", findbyProductInitialize, productId, actionType)
    const resetForm = (obj) => {
        console.log("inside reset function!!", obj,actionType)
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                obj[key] = defaultValues[key];
            }
        }
    }
    return (
        <Formik
            // initialValues={initialValues}
            initialValues={editProductValue}
            enableReinitialize
            validationSchema={productSchema}
            onSubmit={(values, { setSubmitting }) => {
                onSubmit(values)
                // .then(() => {
                    setSubmitting(false);
                    if (actionType === 'add') {
                        resetForm(values);
                    } else {
                        handleStepChange(currentStep + 1);
                    }
                // }).catch(error => {
                //     console.error('Submission error:', error);
                //     setSubmitting(false);
                // });
            }}
        >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                <form onSubmit={(e) => {
                    e.preventDefault(); // Prevent default submission
                    handleSubmit(); // 
                }}>
                    {/* <Box sx={{ display: 'flex', gap: 2 }}> */}
                    <div className="row">
                        <div className="col-md-8 cs-form mb-4">
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                className='md-input'
                                options={productsOptions}
                                getOptionLabel={(option) => option.label || ''}
                                value={productsOptions.find(option => option.label === values.productName) || null}
                                onChange={(event, newValue) => {
                                    // setProducts('productName', newValue ? newValue.label : '');
                                    // handleChange({ target: { name: 'productName', value: newValue?.label || '' } });
                                    handleChange({ target: { name: 'productName', value: newValue?.label || '' } });
                                    const selectedProduct = productsOptions.find(option => option.label === newValue?.label);
                                    // handleChange({ target: { name: 'productId', value: newValue?.id || '' } });
                                    handleChange({ target: { name: 'productId', value: selectedProduct?.value || '' } });

                                }}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={t('addProduct.product')}
                                        name="productName"
                                        error={touched.productName && Boolean(errors.productName)}
                                        helperText={touched.productName && errors.productName}
                                    />
                                )}
                            />

                            {/* <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                className='md-input'
                                options={productsOptions}
                                value={values.productName}
                                onChange={(event, newValue) => {
                                    handleChange({ target: { name: 'productName', value: newValue?.label || '' } });
                                }}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Product"
                                        error={!!errors.productName}
                                        helperText={errors.productName}
                                    />
                                )}
                            /> */}
                        </div>
                        <div className="col-md-3 cs-form mb-2">

                            {/* Additional fields for Blend Percentage, Grams/Linear Meter, and Meters/Garments */}
                            <TextField
                                name="blendPercentage"
                                label={t('addProduct.blend')}
                                className='md-input'
                                type="number"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                InputProps={{
                                    inputProps: { min: 0,  max: 100 }
                                }}
                                error={touched.blendPercentage && Boolean(errors.blendPercentage)}
                                helperText={touched.blendPercentage && errors.blendPercentage}
                            />
                        </div>
                    </div>
                    {/* </Box> */}
                    <div className="row">

                        <Box sx={{ display: 'flex', gap: 4 }}>
                            <div className="col-md-3 cs-form mb-2">
                                <TextField
                                    name="productQty"
                                    label={t('addProduct.quantity')}
                                    className='md-input'
                                    type="number"
                                    value={values.productQty}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    InputProps={{
                                        inputProps: { min: 1 }
                                    }}
                                    error={touched.productQty && Boolean(errors.productQty)}
                                    helperText={touched.productQty && errors.productQty}
                                />
                            </div>
                            <div className="col-md-3 cs-form mb-2">

                                <FormControl className='md-input'
                                >
                                    <InputLabel id="unit-label">Unit *</InputLabel>
                                    <Select
                                        labelId="unit-label"
                                        name="productUom"
                                        value={values.productUom}
                                        label={t('addProduct.unit')}
                                        onChange={handleChange}
                                        error={touched.productUom && Boolean(errors.productUom)}
                                    >
                                        {/* <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value="grams">Grams</MenuItem>
                                        <MenuItem value="meters">Meters</MenuItem> */}
                                        <MenuItem value="">
                                            {/* <em>None</em> */}
                                        </MenuItem>
                                        {unitOptions.map((option) => (
                                            <MenuItem key={option.uom_id} value={option.uom}>
                                                {option.uom}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText>{touched.productUom && errors.productUom}</FormHelperText>
                                </FormControl>
                            </div>
                            { companyRole === 'GM' && <>
                            <div className="col-md-0 cs-form mb-4">

                                <TextField
                                    label={t('addProduct.grams')}
                                    name="glm"
                                    value={values.glm}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!errors.glm}
                                    helperText={errors.glm}
                                />
                            </div>
                            <div className="col-md-2 cs-form mb-2">

                                <TextField
                                    label={t('addProduct.meters')}
                                    name="mpg"
                                    value={values.mpg}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!errors.mpg}
                                    helperText={errors.mpg}

                                />
                            </div>
                            </>
}
                        </Box>
                    </div>
                    <div className='row'>
                        <div className="col-md-12 cs-form mb-3">
                            <TextField
                                name="productDescription"
                                className='md-input'
                                label={t('addProduct.productDescription')}
                                multiline
                                rows={4}
                                value={values.productDescription}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.productDescription && Boolean(errors.productDescription)}
                                helperText={touched.productDescription && errors.productDescription}

                                inputProps={{
                                    maxLength: 300,
                                }}
                            // helperText={`${values.productDescription.length}/300`}
                            />
                        </div>
                    </div>
                    <div className='row'>
                      
                    </div>
                    
                    <div className="d-flex justify-content-between mt-3">
                        <button type="button" className="btn btn-light grey-btn lg-btn" onClick={() => handleStepChange(currentStep - 1,'edit','')}>
                            {t('addProduct.previous')}
                        </button>
                        <div>
                            <button type="submit" className="btn btn-primary greeen-btn lg-btn lg-btn mx-3" onClick={handleSubmit}>
                                {actionType === 'add' ? t('addProduct.addProductbtn') : 'Edit Product'}
                            </button>

                            <button type="submit"
                                className={`btn ${actionType === 'add' ? 'btn-primary greeen-btn' : 'btn-secondary'} lg-btn`}
                                onClick={() => handleStepChange(currentStep + 1)}
                                disabled={!productCount}
                            >
                                {actionType === 'add' ? 'Next' : 'Save Changes'}
                            </button>
                            {/* <button type="submit" className="btn btn-primary greeen-btn lg-btn lg-btn" onClick={() => handleStepChange(currentStep + 1)}>
                                {actionType === 'add' ? t('addProduct.create') : 'Save Changes'}
                            </button> */}
                        </div>
                    </div>
                </form>)
            }
        </Formik >
    )
}
export default AddProductForm